import {
  enterLounge,
  getLoungeRole,
  setLoungeRole,
  getLoungeUsers,
  getContacts,
  noticeUserUpdate,
  getTalkingContacts,
  countVisitor
} from '@/api/vrlounge'
import vrLoungeApiService from '../../../services/api/vrLounge'

const formatUserInfo = (user) => ({
  profileUrl: user.avatar || '',
  country: user.location || '',
  id: user._id || '',
  coverPhotoUrl: user.coverPhoto || '',
  nickname: user.nickname || '',
  position: user.position || '',
  company: user.company || '',
  email: user.email || '',
  phone: user.phone || '',
  name: user.name || ''
})
const formatCardInfo = (contactData) => ({
  id: contactData._id,
  role: contactData.message === '' ? 'sender' : 'receiver',
  loungeId: contactData.lounge,
  message: contactData.message,
  createdAt: contactData.createdAt
})
const getStatus = (contactData, connectionStatus) => {
  let status = ''

  if (connectionStatus === 'SENT') {
    if (contactData.waiting) status = 'SENT'
    else status = 'RECEIVED'
  }
  if (connectionStatus === 'CONNECTED') status = 'CONNECTED'

  if (contactData.blockade) status = 'BLOCK'
  if (contactData.beblockade) status = 'BLOCKED'
  return status
}
const formatContact = (contactData, connectionStatus) => {
  const { carduser, connection } = contactData
  const user = formatUserInfo(carduser)
  const card = formatCardInfo(contactData)
  const status = getStatus(contactData, connectionStatus || connection.status)
  return { user, status, card }
}

const state = {
  vrLounge: null,
  talkingContacts: [],
  hasEntered: false,
  currentModal: '',
  addmissionId: '',
  currentOnline: 0,
  totalVisitor: 0,
  loungeUsers: [],
  prevModal: '',
  contacts: [],
  isMoving: false,
  user: {
    // role
    // id
    // loungeId
    // talkId: talkid
  },
  popupPreviewStatus: false,
  hasChatInit: false,
  activeChat: false,
  selectedContactInfo: null
}

export const getters = {
  vrLounge: state => state.vrLounge,
  talkingContacts: state => state.talkingContacts,
  currentOnline: state => state.currentOnline,
  currentModal: state => state.currentModal,
  addmissionId: state => state.addmissionId,
  totalVisitor: state => state.totalVisitor,
  loungeUsers: state => state.loungeUsers,
  hasChatInit: state => state.hasChatInit,
  hasEntered: state => state.hasEntered,
  activeChat: state => state.activeChat,
  prevModal: state => state.prevModal,
  contacts: state => state.contacts,
  user: state => state.user,
  isMoving: state => state.isMoving,
  isVrloungeActive: (state, getters, rootState) => {
    if (rootState.property.property.vrloungeId) return true
    return false
  },
  loungeId: (state, getters, rootState) => {
    if (!getters.isVrloungeActive) return ''
    if (rootState.property.property.vrloungeId) return rootState.property.property.vrloungeId
    return ''
  },
  contactsByUserId: state => state.contacts.reduce((result, contact) => {
    result[contact.user.id] = contact
    return result
  }, {}),
  loungeUsersByUserId: state => state.loungeUsers.reduce((result, user) => {
    result[user.id] = user
    return result
  }, {}),
  popupPreviewStatus: state => state.popupPreviewStatus,
  helpLink: (state, getters, rootState, rootGetters) => {
    const links = {}
    const hq = rootGetters.headquarter.name
    return links[hq] || null
  },
  selectedContactInfo: state => state.selectedContactInfo
}

export const actions = {
  async fetchVrLounge ({ dispatch, commit, state, rootState }, vrLoungeId = '') {
    const vrLounge = await vrLoungeApiService.fetchVrLounge(vrLoungeId)
    dispatch('setVrLounge', vrLounge)
  },
  setVrLounge ({ commit }, vrLounge) {
    commit('SET_VRLOUNGE', vrLounge)
  },
  setCurrentModal ({ commit }, modalName) {
    commit('SET_CURRENT_MODAL', modalName)
  },
  updateIsMoving ({ commit }, bool) {
    commit('SET_ISMOVING', bool)
  },
  // payload = {id: loungeId, role}
  async initLoungeUser ({ commit }, payload) {
    let user
    try {
      user = await getLoungeRole(payload.id)
      commit('INIT_LOUNGE_USER', user)
    } catch (error) {
      if (error.msg) {
        user = await setLoungeRole(payload)
        commit('INIT_LOUNGE_USER', user)
      } else {
        Promise.reject(error)
      }
    }
  },
  async enterLounge ({ commit }, loungeId) {
    const addmissionId = await enterLounge(loungeId)
    commit('SET_HAS_ENTERED', true)
    commit('SET_LOUNGE_ADDMISSION_ID', addmissionId)
  },
  leaveLounge ({ commit }) {
    commit('SET_HAS_ENTERED', false)
    commit('SET_LOUNGE_ADDMISSION_ID', '')
  },
  async getLoungeUsers ({ commit }, loungeId) {
    const response = await getLoungeUsers(loungeId)
    const loungeUsers = response.list.map(format)
    commit('SET_LOUNGE_USERS', loungeUsers)
    commit('SET_CURRENT_ONLINE', response.currentOnline)
    commit('SET_TOTAL_VISITOR', response.totalVisitor)
    function format (userData) {
      const { user, ...otherInfo } = userData
      user.profileUrl = user.avatar
      user.country = user.location
      user.coverPhotoUrl = user.coverPhoto
      const _id = otherInfo._id // 此_id用來識別 上下線狀態
      const id = user._id // user table id
      delete user.avatar
      delete user.location
      delete user._id
      return { id, _id, ...user, ...otherInfo }
    }
  },

  // config = {_id, id, ...config}
  updateLoungeUser ({ commit, state }, config) {
    commit('UPDATE_LOUNGE_USER', config)
  },

  async noticeUserUpdate () {
    await noticeUserUpdate()
    // nothing in state need to be change
  },

  async getContacts ({ commit }, loungeId) {
    const contacts = await getContacts(loungeId)
    const formatContacts = contacts.map(contact => formatContact(contact))
    commit('SET_CONTACTS', formatContacts)
  },

  async getTalkingContacts ({ commit }, loungeId) {
    const talkingContacts = await getTalkingContacts(loungeId)
    commit('SET_TALKING_CONTACTS', talkingContacts)
  },

  addContact ({ commit }, contact) {
    contact = formatContact(contact, 'SENT')
    commit('ADD_CONTACT', contact)
  },
  updateContact ({ commit }, contact) {
    contact = formatContact(contact, 'CONNECTED')
    commit('UPDATE_CONTACT', contact)
  },
  deleteContact ({ commit }, contact) {
    contact = formatContact(contact, 'SENT')
    commit('DELETE_CONTACT', contact)
  },
  setHasChatInit ({ commit }, bool) {
    commit('SET_HAS_CHAT_INIT', bool)
  },
  setActiveChat ({ commit }, bool) {
    commit('SET_CHAT_ACTIVE', bool)
  },
  setSelectedContact ({ commit }, contact) {
    commit('SET_SELECTED_CONTACT', contact)
  },
  async countVisitor ({ commit }, { lounge }) {
    await countVisitor({ lounge })
  }
}

export const mutations = {
  SET_VRLOUNGE (state, vrLounge) {
    state.vrLounge = vrLounge
  },
  SET_CURRENT_MODAL (state, modalName) {
    state.prevModal = state.currentModal
    state.currentModal = modalName
  },
  SET_HAS_ENTERED (state, bool) {
    state.hasEntered = bool
  },
  INIT_LOUNGE_USER (state, userData) {
    state.user = {
      role: userData.role,
      id: userData.user._id,
      loungeId: userData.lounge,
      talkId: userData.talkid
    }
  },
  SET_LOUNGE_ADDMISSION_ID (state, id) {
    state.addmissionId = id
  },
  SET_LOUNGE_USERS (state, users) {
    state.loungeUsers = users
  },
  UPDATE_LOUNGE_USER (state, config) {
    const index = state.loungeUsers.findIndex(user => user.id === config.id || user._id === config._id)
    if (index === -1) return
    const updateUser = { ...state.loungeUsers[index], ...config }
    state.loungeUsers.splice(index, 1, updateUser)
  },
  SET_CURRENT_ONLINE (state, number) {
    state.currentOnline = number
  },
  SET_TOTAL_VISITOR (state, number) {
    state.totalVisitor = number
  },
  SET_CONTACTS (state, contacts) {
    state.contacts = contacts
  },
  SET_TALKING_CONTACTS (state, contacts) {
    state.talkingContacts = contacts
  },
  ADD_CONTACT (state, contact) {
    state.contacts.unshift(contact)
  },
  UPDATE_CONTACT (state, contact) {
    const foundContactIndex = state.contacts.findIndex(item => item.user.id === contact.user.id)
    if (foundContactIndex !== -1) state.contacts.splice(foundContactIndex, 1, contact)
    else state.contacts.unshift(contact) // basicly this would never happen
  },
  DELETE_CONTACT (state, contact) {
    const foundContactIndex = state.contacts.findIndex(item => item.user.id === contact.user.id)
    if (foundContactIndex !== -1) state.contacts.splice(foundContactIndex, 1)
    // eslint-disable-next-line no-empty
    else {} // basicly this would never happen
  },
  SET_ISMOVING (state, bool) {
    state.isMoving = bool
  },
  TRIGGER_POPUP_PREVIEW (state) {
    state.popupPreviewStatus = !state.popupPreviewStatus
  },
  SET_HAS_CHAT_INIT (state, bool) {
    state.hasChatInit = bool
  },
  SET_CHAT_ACTIVE (state, bool) {
    state.activeChat = bool
  },
  SET_SELECTED_CONTACT (state, contact) {
    state.selectedContactInfo = contact
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
